/**
 * #rerender_ui.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
function createBaseRerenderEffect() {
    return { delaySeconds: undefined };
}
export const RerenderEffect = {
    $type: "devvit.ui.effects.v1alpha.RerenderEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.delaySeconds !== undefined) {
            writer.uint32(13).float(message.delaySeconds);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRerenderEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.delaySeconds = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { delaySeconds: isSet(object.delaySeconds) ? globalThis.Number(object.delaySeconds) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.delaySeconds !== undefined) {
            obj.delaySeconds = message.delaySeconds;
        }
        return obj;
    },
    create(base) {
        return RerenderEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRerenderEffect();
        message.delaySeconds = object.delaySeconds ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(RerenderEffect.$type, RerenderEffect);
function isSet(value) {
    return value !== null && value !== undefined;
}
